import { Component } from 'react';
import PatientDocumentInfoTextTooltip from '../../../components/patientDocumentInfoTextTooltip';

/**
 * @typedef {Object} Props
 * @property {string} dashboardUrl
 * @property {string} sessionCode
 * @property {('patient' | 'inbox' | 'outbox' | 'report')} type
 * @property {string} [patientSSN]
 * @property {string} [patientName]
 * @property {number} [departmentId]
 * @property {string} [requisitionId]
 * @property {string} [title]
 * @property {{
 *   phone?: string;
 *   email?: string;
 *   userData?: {sex?: string; name?: string};
 *   city?: string;
 *   zip?: string;
 *   street?: string;
 * }} [patientData]
 */

/**
 * @class
 * @augments {Component<Props, State>}
 */
export default class LabPortalenComponent extends Component {
    /**
    * 
    * @param {Props} props 
    */
    constructor(props) {
        super(props);
        const src = this.getSrcUrl(props);
        this.state = {
            src,
        }
    }

    /**
     * 
     * @param {Props} props 
     */
    getSrcUrl = (props) => {
        if (!props || !props?.dashboardUrl || !props?.sessionCode) return null;

        if (props.type === 'patient') {
            if (props.patientSSN && props.patientName) {
                const url = new URL(props.dashboardUrl);
                const params = new URLSearchParams();

                params.set("sessioncode", props.sessionCode);
                params.set("PID", props.patientSSN);
                params.set("PNAME", props.patientName);

                if (props.patientData?.street) params.set("address1", props.patientData.street);
                if (props.patientData?.zip) params.set("zip", props.patientData.zip);
                if (props.patientData?.city) params.set("city", props.patientData.city);
                if (props.patientData?.phone) params.set("phone", props.patientData.phone);
                if (props.patientData?.email) params.set("mail", props.patientData.email);
                if (props.departmentId) params.set("patientDepartmentID", props.departmentId);

                url.search = params.toString();

                return url.toString();
            }
        } else if (props.type === 'inbox') {
            const url = new URL(props.dashboardUrl);
            const params = new URLSearchParams();

            params.set("sessioncode", props.sessionCode);
            params.set("BoxType", "IN");
            if (props.departmentId) params.set("patientDepartmentID", props.departmentId);

            url.search = params.toString();

            return url.toString();
        } else if (props.type === 'outbox') {
            const url = new URL(props.dashboardUrl);
            const params = new URLSearchParams();

            params.set("sessioncode", props.sessionCode);
            params.set("BoxType", "OUT");
            if (props.departmentId) params.set("patientDepartmentID", props.departmentId);

            url.search = params.toString();

            return url.toString();
        } else if (props.type === 'report') {
            const url = new URL(props.dashboardUrl);
            const params = new URLSearchParams();

            params.set("sessioncode", props.sessionCode);
            params.set("RequisitionID", props.requisitionId);
            params.set("PID", props.patientSSN);

            if (props.departmentId) params.set("patientDepartmentID", props.departmentId);

            url.search = params.toString();
            return url.toString();
        }

        return null;
    };

    componentDidUpdate(prevProps) {
        if (prevProps?.dashboardUrl !== this.props?.dashboardUrl || prevProps?.sessionCode !== this.props?.sessionCode || prevProps?.patientSSN !== this.props?.patientSSN || prevProps?.patientName !== this.props?.patientName || prevProps?.departmentId !== this.props?.departmentId || prevProps?.type !== this.props?.type || prevProps?.requisitionId !== this.props?.requisitionId) {
            this.setState({
                src: null
            }, () => {
                const src = this.getSrcUrl(this.props);
                this.setState({
                    src
                })
            });
        }
    }

    render() {
        // console.log('LabPortalenComponent', this.state.src);

        if (!this.state.src) return null;
        return (
            <div className='panel' style={{
                height: this.props.title ? '120vh' : '110vh',
                minHeight: this.props.title ? '120vh' : '110vh',
                maxHeight: this.props.title ? '120vh' : '110vh',

                width: '100%'
            }}>
                {this.props.title ? <div style={{}}>
                    <h2 style={{
                        fontSize: 22,
                        textAlign: 'left',
                        padding: 0,
                        margin: 0,
                        marginBottom: 20,
                    }}>
                        <span style={{ marginRight: 10 }}>{this.props.title.translate(this.props.lang)}</span>
                        <PatientDocumentInfoTextTooltip
                            lang={this.props.lang}
                            text='Curoflow has no control over data in LabPortalen. Please double check the data before sharing with patients.'
                        />
                    </h2>
                </div> : null}
                <iframe
                    src={this.state.src}
                    style={{ height: '100%', width: '100%', border: 'none' }}
                />
            </div>
        )
    }
}